// Hook for admin/organizer portal translations. Reuses the app-wide language
// state from LanguageContext so the marketing-site switcher and the portal
// switcher stay in sync.
//
//   const { t, tEnum, language, setLanguage } = usePortalT();
//   t('common.save')                    -> 'Save' | '保存'
//   t('activities.drawDone', { n: 3 })  -> 'Lottery drawn, 3 winner(s)'
//   tEnum('configStatus', 'published')  -> 'Published' | '已上架'

import { useMemo } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { portal, portalEnums } from './portal';

function interpolate(str, vars) {
  if (!vars || typeof str !== 'string') return str;
  return str.replace(/\{(\w+)\}/g, (_, k) => (vars[k] != null ? String(vars[k]) : ''));
}

export function usePortalT() {
  const { language, setLanguage } = useLanguage();
  const lang = language === 'zh' ? 'zh' : 'en';

  return useMemo(() => {
    const dict = portal[lang] || portal.en;
    const t = (key, vars) => {
      const raw = String(key).split('.').reduce((o, k) => (o == null ? o : o[k]), dict);
      return raw == null ? key : interpolate(raw, vars);
    };
    const tEnum = (group, value) => {
      const entry = portalEnums[group]?.[value];
      if (!entry) return value == null ? '' : String(value);
      return entry[lang] || entry.en || String(value);
    };
    return { t, tEnum, language: lang, setLanguage };
  }, [lang, setLanguage]);
}

export default usePortalT;
